.propertyGroup {
    display: flex;
    margin: 20px 0px 0px 0px;
}

.propertyContainer {
    flex: 1;
    margin: 0px 10px;
}

.formFieldGroup {
    display: flex;
    gap: 10px;
}

.formFieldContainer {
    flex: 1;
    margin-bottom: 20px;
    max-width: 100%;
}

.controlMappingContainer {
    flex: 1;
    max-width: 100%;
    padding: 0px 10px;
}

.deleteButton {
    margin-right: auto;
}

.buttonContainer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 8px;
    margin: 10px 0;
}
